<template>
    <div class="col-md-12 eventcard mx-0 mx-md-4" v-if="this.event.event_name.length>0">
        <div class="date">
            <div class="sDate">
                <div class="day">{{formateDate(event.start_date)}}</div>            
                <div class="monthyear">{{formateMonthYear(event.start_date)}}</div>
            </div>            
            <div class="eMonth">
                <div>
                    {{this.EndsOn}}
                </div>
                <div>
                    {{formatFullDate(event.end_date)}}
                </div>
            </div>
        </div>
        <div class="eventDesc">
            <div class="heading"> {{event.event_name}}</div>
            <div class="content">{{truncate(event.description,20)}}</div>
            <div><a class="review" target="_blank" :href="event.publishingURL">{{this.ViewEvent}}</a></div>
        </div>
    </div>
    <div v-else class="heading">
        {{this.NoUpcomingEvents}}
    </div>
</template>
<script>
    import {endsOn,noEvent,viewEvent} from '../../constants/labels.config'
    export default {
        name: "EventCard",
        props: ["event"],
        data(){
            return{
                NoUpcomingEvents:noEvent,
                EndsOn:endsOn,
                ViewEvent:viewEvent,
            }            
        },
        methods: {
            formateMonthYear(date) {
                const monthNames = ["January", "February", "March", "April", "May", "June",
                                    "July", "August", "September", "October", "November", "December"];
                const dt = new Date(date);
                return monthNames[dt.getMonth()]+', '+dt.getFullYear();
            },
            formateDate(date) {
                const dt = new Date(date);
                return dt.getDate();
            },
            formatFullDate(date)
            {
                if(date==undefined || date==null || date=="")
                    return "";

                var d=new Date(date);
                var s=d.toString().substr(4,3)+' '+d.getDate()+', '+d.getFullYear();
                return s;
            },
            truncate(data, no_words) {
                return data.split(" ").splice(0, no_words).join(" ");
            }
        }
    }
</script>